/** @format */

import {AccountsKpiName} from 'graphql/generated/types';

/**
 * Возвращает единицу измерения для KPI метрики
 */
export const getKpiUnit = (kpiName: AccountsKpiName): string => {
  switch (kpiName) {
    case 'CPL':
    case 'CPC':
    case 'CPM':
    case 'REVENUE':
    case 'AVG_VIDEO_COMPLETE_COST':
      return '₽';
    case 'DRR':
    case 'VTR':
    case 'ER':
    case 'ROMI':
      return '%';
    default:
      return '';
  }
};

